import React from "react";
import "./App.css";
import "./styles/landing.css";
import Header from "./components/landing/Header";
import HeroSection from "./components/landing/HeroSection";
import AboutSection from "./components/landing/AboutSection";
import ServicesSection from "./components/landing/ServicesSection";
import ProcessSection from "./components/landing/ProcessSection";
import WhyChooseSection from "./components/landing/WhyChooseSection";
import ContactSection from "./components/landing/ContactSection";
import Footer from "./components/landing/Footer";
import ChatWidget from "./components/landing/ChatWidget";

function App() {
  return (
    <div className="landing-page">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ProcessSection />
      <WhyChooseSection />
      <ContactSection />
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default App;
